import { version } from '../../package.json';

const TITLE = '';

export default{
  LOGIN: `${TITLE} Login`,
  SIGNUP: `${TITLE} Sign up`,
  RESET_PASSWORD: `${TITLE} Reset password`,
  OTP: `${TITLE} OTP`,
  DASHBOARD: `${TITLE} Dashboard`,
  PROFILE: `${TITLE} Profile`,
  FUNDS: `${TITLE} Transactions`,
  PAN: `${TITLE} PAN`,
  IPV: `${TITLE} IPV`,
  AADHAAR: `${TITLE} Aadhaar verification`,
  AADHAAR_VERIFY: `${TITLE} User details`,
  UPLOAD_DOCS: `${TITLE} Upload docs`,
  DOC_VERIFY: `${TITLE} Document verification`,
  PORTFOLIO_LIST: `${TITLE} Portfolio list`,
  BASE_URL: process.env.PUBLIC_URL,
  VERSION: version
};
